import React, { useMemo, useState } from 'react';
import Header3 from '../LandingPage/Header3';
import { MimaText, Searchbar } from '../../components';
import styles from '../../assets/styles/Blog/Blog.module.scss';
import { IoArrowForward } from 'react-icons/io5';
import { blogTags, blogContent } from '../../utils/blog';
import { Link } from 'react-router-dom';
import Footer from '../LandingPage/Footer';

const BlogLanding = ({ goToBlogPost }) => {


    const navItems = blogTags

    const [selectedNav, setSelectedNav] = useState(0)
    const [selectedMenu, setSelectedMenu] = useState("All")
    const [filteredPosts, setFilteredPosts] = useState([])

    const postsAvailable = useMemo(() => {
        if (selectedMenu === "All") {
            return blogContent.sort((a, b) => b._id - a._id)
        } else {
            return blogContent.filter((x) => {
                return x.tags.includes(selectedMenu)
            }).sort((a, b) => b._id - a._id);
        }
    }, [selectedMenu])


    return (
        <>
            <Header3 />
            <div className={styles.title}>
                <MimaText variant="h1" align="center" mb={1}>Blog</MimaText>
                <MimaText variant="body2" align="center">Learn more about growing and managing your business with Mima.</MimaText>
            </div>
            <div className={styles.nav}>
                <div className={styles.nav__item}>
                    {navItems.map((item, i) => (
                        <nav
                            key={i}
                            className={selectedNav === i ? styles.nav__item__selected : ""}
                            onClick={() => {
                                setSelectedNav(i)
                                setSelectedMenu(item)
                            }}
                        >
                            {item}
                        </nav>
                    ))}
                </div>

                <Searchbar
                    placeholder="Search Article Titles"
                    input={postsAvailable}
                    loading={false}
                    output={setFilteredPosts}
                    handleFilter={(item, searchQuery) => {
                        return (
                            item?.title
                                ?.toLowerCase()
                                ?.includes(searchQuery)
                        );
                    }}
                />

            </div>
            <section className={styles.container}>
                {filteredPosts.length === 0 ? (
                    <>
                        <MimaText align="center" variant="h2" color="var(--color-grey)" mt={5} mb={5}> Regrettably, the title you entered did not match any existing articles in our database. Kindly consider searching for an alternative article title</MimaText>
                    </>
                ) : (
                    <div className={styles.blog__list}>
                        {filteredPosts?.map((blog) => (
                            <Link to={blog.link}>
                                <div key={blog._id} className={styles.blog__list__single} onClick={() => {
                                    goToBlogPost(blog)
                                }}>
                                    <div className={styles.blog__list__single__img__container}>
                                        <img src={blog.titleImage} alt={blog.title} className={styles.blog__list__single__img} />
                                    </div>

                                    <div className={styles.blog__list__single__flex}>
                                        <div className={styles.blog__list__single__tags}>
                                            {blog.tags.map((x) => (
                                                <div>
                                                    {x}
                                                </div>
                                            ))}
                                        </div>
                                        <MimaText variant="small">
                                            {blog.readTime} Read
                                        </MimaText>
                                    </div>
                                    <MimaText variant="subtitleBold">
                                        {blog.title}
                                    </MimaText>
                                    <MimaText>
                                        {blog.summary}
                                    </MimaText>
                                    <div className={styles.blog__list__single__read}>
                                        Read More <IoArrowForward />
                                    </div>

                                </div>
                            </Link>

                        ))}
                    </div>
                )}



            </section>

            <Footer />
        </>
    )
}

export default BlogLanding